// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Announce-module--wrapper--1N05l","imgWrapper":"Announce-module--imgWrapper--2udUO","name":"Announce-module--name--1JkFI"};